
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardTeachTime from '../../components/Dashboards/DashboardTeachTime.vue'
  @Component({
    name: 'student',
    components: { DashboardTeachTime }
  })
export default class student extends Vue {
  mounted() {}
}
